const formatDate = (columns: { dataField: string; dataType?: string }[], filters: any) => {
  const columnDataType = columns.filter((e) => e.dataField === filters[0])[0].dataType;
  if (columnDataType === 'date') {
    filters[2] = new Date(filters[2]).toLocaleDateString('zh-CN');
  }
};

export const clearFilters = (
  queryFilters: any,
  columns: { dataField: string; dataType?: string }[],
): { filtersClean: any[]; filterColumns: string[] } => {
  const filterColumns: string[] = [];
  if (queryFilters?.length > 0 && columns.length) {
    if (
      typeof queryFilters[0] === 'string' &&
      columns.some((e) => e.dataField === queryFilters[0])
    ) {
      formatDate(columns, queryFilters);
      filterColumns.push(queryFilters[0]);
      return { filtersClean: [...queryFilters], filterColumns };
    } else {
      const filtersChecked = queryFilters.filter(
        (f: any) => typeof f !== 'string' && columns.some((e) => e.dataField === f[0]),
      );
      if (filtersChecked.length === 1) {
        formatDate(columns, queryFilters[0]);
        filterColumns.push(queryFilters[0][0]);

        return { filtersClean: [...filtersChecked[0]], filterColumns };
      } else if (filtersChecked.length > 1) {
        const filtersWithAnd: any[] = [];
        filtersChecked.forEach((f: any, index: number) => {
          formatDate(columns, f);
          filtersWithAnd.push(f);
          filterColumns.push(f[0]);

          if (index < filtersChecked.length - 1) {
            filtersWithAnd.push('AND');
          }
        });
        return { filtersClean: [...filtersWithAnd], filterColumns };
      }
    }
  }
  return { filtersClean: [], filterColumns };
};
